<template>
  <div class="flex-container d-flex flex-column inquiry">
    <div class="relative flex-container d-flex flex-column ai-center">
      <div v-if="!isMobile" class="mg-150" />
      <div v-else class="mg-50" />

      <div
        class="section-wrapper d-flex flex-column mg-150"
        v-bind:class="{ 'mg-50': isMobile }"
      >
        <div class="header-2 kor" v-bind:class="{ 'text-lg': isMobile }">
          데이터바우처 컨설팅 문의
        </div>
        <div class="mg-50" />
        <div class="text-2 opaque">
          2021년 데이터바우처 지원사업은 데이터몬스터즈와 함께!<br />
          답변 가능하신 항목을 채워주시면 정확한 상담에 도움이 됩니다.
        </div>
        <div class="mg-50" />
        <div class="text-1 text-underline">
          ※ 하단 문의란 내, (선택사항) 으로 표기된 항목을 제외한
          <br v-if="isMobile" />모든 항목은 필수입력 입니다.
        </div>
        <div class="mg-50" />

        <v-form v-model="valid">
          <div class="text-lg">
            <b>1. 연락처</b>
          </div>
          <template v-if="isMobile">
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="name"
                  :rules="requiredRules"
                  color="#1c1c1c"
                  placeholder="이름"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="phoneNumber"
                  :rules="requiredRules"
                  color="#1c1c1c"
                  placeholder="전화번호"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="email"
                  :rules="requiredRules"
                  color="#1c1c1c"
                  placeholder="이메일"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="companyName"
                  :rules="requiredRules"
                  color="#1c1c1c"
                  placeholder="회사/기관명"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="teamName"
                  color="#1c1c1c"
                  placeholder="소속부서 (선택사항)"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="duty"
                  color="#1c1c1c"
                  placeholder="직책 (선택사항)"
                />
              </v-col>
            </v-row>
          </template>
          <template v-else>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="name"
                  :rules="requiredRules"
                  color="#1c1c1c"
                  placeholder="이름"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="duty"
                  color="#1c1c1c"
                  placeholder="직책 (선택사항)"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="companyName"
                  :rules="requiredRules"
                  color="#1c1c1c"
                  placeholder="회사/기관명"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="teamName"
                  color="#1c1c1c"
                  placeholder="소속부서 (선택사항)"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="phoneNumber"
                  :rules="requiredRules"
                  color="#1c1c1c"
                  placeholder="전화번호"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="email"
                  :rules="requiredRules"
                  color="#1c1c1c"
                  placeholder="이메일"
                />
              </v-col>
            </v-row>
          </template>
          <div class="text-lg mg-50">
            <b>2. 문의 출처</b>
          </div>

          <div class="text-2 opaque">최소 1개 선택</div>

          <v-row>
            <v-col cols="12" md="3">
              <v-checkbox
                v-model="path"
                color="#1c1c1c"
                value="A_PORTAL"
                :label="`데이터스토어/데이터바우처 포털`"
              />
            </v-col>
            <v-col cols="12" md="2">
              <v-checkbox
                v-model="path"
                color="#1c1c1c"
                value="B_DOCUMENT"
                label="이메일 홍보"
              />
            </v-col>
            <v-col cols="12" md="2">
              <v-checkbox
                v-model="path"
                color="#1c1c1c"
                value="C_RECOMMEND"
                label="지인추천"
              />
            </v-col>
            <v-col cols="12" md="2">
              <v-checkbox
                v-model="path"
                color="#1c1c1c"
                value="D_SEARCH"
                label="인터넷 검색"
              />
            </v-col>
            <v-col cols="12" md="2">
              <v-checkbox
                v-model="path"
                color="#1c1c1c"
                value="E_DBR"
                label="DBR"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="1">
              <v-checkbox
                v-model="path"
                color="#1c1c1c"
                value="ETC"
                label="기타"
              />
            </v-col>
            <v-col cols="12" md="3"
              ><v-text-field
                :disabled="!path.includes('ETC')"
                color="#1c1c1c"
                placeholder="기타 사항을 기재해주세요"
                v-model="pathEtc"
            /></v-col>
          </v-row>

          <div class="text-lg mg-50">
            <b>3. 가공 대상 데이터 형식</b>
          </div>
          <div class="mt-5 text-2">
            <b>3-1. 데이터 보유 여부</b>
          </div>

          <v-radio-group v-model="dataStatus" :row="!isMobile">
            <v-radio color="#1c1c1c" value="A_HAVEDATA" label="데이터 보유" />
            <v-radio
              color="#1c1c1c"
              value="B_NEEDDATA"
              label="데이터 보유하고 있으나, 추가 수집 필요"
            />
            <v-radio color="#1c1c1c" value="C_NODATA" label="데이터 미보유" />
          </v-radio-group>

          <div class="text-2">
            <b>3-2. 데이터 설명 (보유 데이터/원하는 데이터 등)</b>
          </div>
          <v-row>
            <v-col cols="12" md="12">
              <v-textarea
                v-model="dataExplain"
                :rules="requiredRules"
                placeholder="컨설팅을 의뢰할 데이터에 대해 구체적으로 설명해주세요. (보유 데이터 설명, 필요 데이터 등)"
                color="#1c1c1c"
                outlined
              />
            </v-col>
          </v-row>
          <div class="text-2">
            <b>3-3. 데이터 형식</b>
          </div>
          <div class="text-2 opaque">최소 1개 선택</div>
          <v-row>
            <v-col cols="12" md="2">
              <v-checkbox
                v-model="dataType"
                :rules="requiredRules"
                color="#1c1c1c"
                value="A_CSV"
                label="정형(CSV)"
              />
            </v-col>
            <v-col cols="12" md="2">
              <v-checkbox
                v-model="dataType"
                color="#1c1c1c"
                value="B_JSON"
                label="비정형(JSON)"
              />
            </v-col>
            <v-col cols="12" md="2">
              <v-checkbox
                v-model="dataType"
                color="#1c1c1c"
                value="C_TEXT"
                label="텍스트"
              />
            </v-col>
            <v-col cols="12" md="2">
              <v-checkbox
                v-model="dataType"
                color="#1c1c1c"
                value="D_VOICE"
                label="음성"
              />
            </v-col>
            <v-col cols="12" md="2">
              <v-checkbox
                v-model="dataType"
                color="#1c1c1c"
                value="E_MEDIA"
                label="이미지/영상"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="1">
              <v-checkbox
                v-model="dataType"
                color="#1c1c1c"
                value="ETC"
                label="기타"
              />
            </v-col>
            <v-col cols="12" md="3"
              ><v-text-field
                :disabled="!dataType.includes('ETC')"
                color="#1c1c1c"
                placeholder="기타 사항을 기재해주세요"
                v-model="dataTypeEtc"
            /></v-col>
          </v-row>

          <div class="text-2">
            <b>3-4. 데이터 형식 설명</b>
          </div>
          <v-row>
            <v-col cols="12" md="12">
              <v-textarea
                v-model="dataTypeExplain"
                :rules="requiredRules"
                placeholder="컨설팅을 의뢰할 데이터 형식에 대해 구체적으로 설명해 주세요.(기보유 혹은 수집 필요한 데이터 등)"
                color="#1c1c1c"
                outlined
              />
            </v-col>
          </v-row>
          <div class="text-2">
            <b>3-5. 데이터 샘플 첨부 (선택사항)</b>
          </div>
          <v-row>
            <v-col cols="12" md="12">
              <v-file-input
                v-model="sample"
                show-size
                :rules="fileRules"
                placeholder="파일을 업로드 해주세요. (PPT, DOC, PDF, HWP, ZIP, JPG, PNG / 최대 30MB)"
                messages="여러 개의 파일은 하나로 압축해서 업로드 해주세요."
              />
            </v-col>
          </v-row>

          <div class="text-lg mg-50">
            <b>4. 데이터 가공 방식</b>
          </div>
          <div class="text-2 opaque">최소 1개 선택</div>
          <v-row dense>
            <v-col cols="12" md="2">
              <v-checkbox
                v-model="dataProcess"
                color="#1c1c1c"
                value="A_PROCESS"
                label="데이터 가공"
              />
            </v-col>
            <v-col cols="12" md="2">
              <v-checkbox
                v-model="dataProcess"
                color="#1c1c1c"
                value="B_MODELING"
                label="데이터 분석/모델링"
              />
            </v-col>
            <v-col cols="12" md="2">
              <v-checkbox
                v-model="dataProcess"
                color="#1c1c1c"
                value="C_CREATE"
                label="데이터 생성"
              />
            </v-col>
            <v-col cols="12" md="2">
              <v-checkbox
                v-model="dataProcess"
                color="#1c1c1c"
                value="D_PREPROCESS"
                label="데이터 전처리"
              />
            </v-col>
            <v-col cols="12" md="2">
              <v-checkbox
                v-model="dataProcess"
                color="#1c1c1c"
                value="E_CONSULT"
                label="데이터 컨설팅"
              />
            </v-col>
            <v-col cols="12" md="2">
              <v-checkbox
                v-model="dataProcess"
                color="#1c1c1c"
                value="F_QUALITY"
                label="데이터 품질개선"
              />
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" md="2">
              <v-checkbox
                v-model="dataProcess"
                color="#1c1c1c"
                value="G_VISUALIZE"
                label="리포팅(시각화)"
              />
            </v-col>
            <v-col cols="12" md="2">
              <v-checkbox
                v-model="dataProcess"
                color="#1c1c1c"
                value="H_BUILD"
                label="시스템 구축"
              />
            </v-col>
            <v-col cols="12" md="1">
              <v-checkbox
                v-model="dataProcess"
                color="#1c1c1c"
                value="ETC"
                label="기타"
              />
            </v-col>
            <v-col cols="12" md="3"
              ><v-text-field
                :disabled="!dataProcess.includes('ETC')"
                color="#1c1c1c"
                placeholder="기타 사항을 기재해주세요"
                v-model="dataProcessEtc"
            /></v-col>
          </v-row>

          <div class="text-lg mg-50">
            <b>5. 최종 산출물 유형</b>
          </div>
          <v-row>
            <v-col cols="12" md="12">
              <v-textarea
                v-model="resultTypeExplain"
                :rules="requiredRules"
                placeholder="최종 산출물 유형 요건을 구체적으로 기재해주세요.(파일 형식, 데이터 분량 등) 
(ex) 구매이력 분석을 통한 사용자 데모그래픽 기반 추천상품 예측 모델을 만들고 싶습니다.
(ex) 자율주행 자동차 사고감지를 위한 서비스를 개발하고 있습니다. 약 300,000건의 교통 정보 데이터를 보유중인데 
서비스 목적에 맞도록 데이터를 전처리 및 정형화 하고자 합니다."
                color="#1c1c1c"
                outlined
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12">
              <v-checkbox
                v-model="marketingAgreement"
                color="#1c1c1c"
                label="개인정보 수집 및 이용에 동의합니다."
              ></v-checkbox>
            </v-col>
          </v-row>
          <table
            v-if="!isMobile"
            class="flex-container market-agreement opaque"
          >
            <thead></thead>
            <tbody>
              <tr>
                <th>수집 및 이용 목적</th>
                <td>이용자 식별 / 문의 접수 및 답변 발송</td>
              </tr>
              <tr>
                <th>수집하는 개인정보 항목</th>
                <td>
                  이름, 소속, 연락처, 이메일, 문의내용 등 신청서에 기재된 정보
                  또는 신청자가 제공한 정보
                </td>
              </tr>
              <tr>
                <th>보유 및 이용 기간</th>
                <td>
                  수집 및 이용 동의일로부터 수집 및 이용 목적을 달성할때까지<br />
                  (목적 달성 이후에는 수집 ･ 이용한 개인 정보를 즉시 파기합니다.
                  단, 관계법령의 규정에 의하여 보전할 필요가 있는 경우 일정 기간
                  동안 개인정보를 보관할 수 있습니다.)
                </td>
              </tr>
            </tbody>
          </table>
          <div v-else class="text-2 opaque">
            <div>
              <b>수집 및 이용 목적</b>
            </div>
            <div>이용자 식별 / 문의 접수 및 답변 발송</div>
            <div class="mt-2">
              <b>수집하는 개인정보 항목</b>
            </div>
            <div>
              이름, 소속, 연락처, 이메일, 문의내용 등 신청서에 기재된 정보 또는
              신청자가 제공한 정보
            </div>
            <div class="mt-2">
              <b>보유 및 이용 기간</b>
            </div>
            <div>
              수집 및 이용 동의일로부터 수집 및 이용 목적을 달성할때까지<br />
              (목적 달성 이후에는 수집 ･ 이용한 개인 정보를 즉시 파기합니다. 단,
              관계법령의 규정에 의하여 보전할 필요가 있는 경우 일정 기간 동안
              개인정보를 보관할 수 있습니다.)
            </div>
          </div>
          <div class="market-agreement opaque mt-5 ml-1">
            ※ 귀하께서는 본 안내에 따른 개인정보 수집, 이용에 대하여 동의를
            거부하실 권리가 있습니다. 다만, 문의 응대를 위해 필요한 최소한의
            개인정보이므로 동의를 해주셔야 문의 접수가 가능한 점 양해
            부탁드립니다.
          </div>
          <div class="mg-50" />
          <div class="flex-container jc-center">
            <v-btn width="250" color="primary" @click="onClickSubmit">
              제출
            </v-btn>
          </div>
        </v-form>

        <div class="mg-150" />
      </div>
    </div>
  </div>
</template>

<script>
import s3 from "@/aws";

export default {
  computed: {
    isMobile() {
      return window.innerWidth < 1000;
    },
  },
  data: () => ({
    name: null,
    duty: null,
    companyName: null,
    teamName: null,
    phoneNumber: null,
    email: null,
    path: [],
    pathEtc: null,
    marketingAgreement: false,
    dataStatus: null,
    dataExplain: null,
    dataType: [],
    dataTypeEtc: null,
    dataTypeExplain: null,
    sample: null,
    dataProcess: [],
    dataProcessEtc: null,
    resultTypeExplain: null,

    valid: false,
    requiredRules: [(v) => !!v || "필수 입력 값입니다."],
    emailRules: [
      (v) => !!v || "필수 입력 값입니다.",
      (v) =>
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
        "올바른 형식의 이메일을 입력해주세요.",
    ],
    fileRules: [
      (value) =>
        !value ||
        value.size < 30000000 ||
        "30MB 미만의 파일만 업로드 가능합니다.",
    ],
  }),
  methods: {
    onChangePath(value) {
      console.log(value);
    },
    onClickSubmit() {
      if (!this.valid) {
        alert("입력사항을 확인해주세요.");
        return;
      }

      if (!this.marketingAgreement) {
        alert("개인정보 수집 및 이용안내에 동의해주세요.");
        return;
      }

      if (this.path.length === 0) {
        alert("문의 출처를 확인해주세요.");
        return;
      }

      if (!this.dataStatus) {
        alert("데이터 보유여부를 확인해주세요.");
        return;
      }

      if (this.dataType.length === 0) {
        alert("데이터 형식을 확인해주세요.");
        return;
      }

      if (this.dataProcess.length === 0) {
        alert("데이터 가공 방식을 확인해주세요.");
        return;
      }

      let that = this;

      if (this.sample) {
        const sample = this.sample;

        s3.upload(
          {
            Bucket: "dm-homepage-storage",
            Key: sample.name,
            Body: sample,
            ACL: "public-read",
          },
          function (err, data) {
            if (err) {
              return alert(
                "샘플 업로드 중 에러가 발생했습니다: " + err.message
              );
            }

            that.makeInquiry(data.Location);
          }
        );
      } else {
        this.makeInquiry(null);
      }
    },

    makeInquiry(sampleUrl) {
      this.$apollo
        .mutate({
          mutation: require("../graphql/CreateVoucherInquiry.gql"),
          variables: {
            name: this.name,
            duty: this.duty,
            companyName: this.companyName,
            teamName: this.teamName,
            phoneNumber: this.phoneNumber,
            email: this.email,
            path: JSON.stringify(this.path),
            pathEtc: this.pathEtc,
            marketingAgreement: this.marketingAgreement,
            dataStatus: JSON.stringify([this.dataStatus]),
            dataExplain: this.dataExplain,
            dataType: JSON.stringify(this.dataType),
            dataTypeExplain: this.dataTypeExplain,
            dataTypeEtc: this.dataTypeEtc,
            sampleUrl,
            dataProcess: JSON.stringify(this.dataProcess),
            dataProcessEtc: this.dataProcessEtc,
            resultTypeExplain: this.resultTypeExplain,
          },
        })
        .then((response) => {
          if (response.data.CreateVoucherInquiry.ok) {
            alert(
              "성실한 답변 감사합니다.\n기재해주신 내용은 꼼꼼히 검토 후 3일 내 연락 드리도록 하겠습니다.\n데이터몬스터즈와 함께 지원 문의해주셔서 감사합니다."
            );
            this.$router.push("/datavoucher");
          } else {
            alert(response.data.CreateVoucherInquiry.error);
          }
        })
        .catch((err) => {
          alert("GraphQL 오류가 발생했습니다:", err.message);
          return;
        });
    },
  },

  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>

<style>
.market-agreement {
  font-size: 10px;
  margin-top: -30px;
}

.market-agreement th {
  text-align: start;
  padding: 5px;
  padding-right: 15px;
}
</style>